var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: _vm.PERMISSIONS.VIEW_PORTFOLIO,
          expression: "PERMISSIONS.VIEW_PORTFOLIO",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c(
        "b-card",
        {
          attrs: {
            "no-body": true,
            "footer-class": "px-3 py-2 card-footer-action",
          },
        },
        [
          _c(
            "b-card-body",
            { staticClass: "p-3 clearfix" },
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("i", {
                      staticClass:
                        "fa fa-sitemap bg-primary p-3 font-2xl mr-3 float-left",
                    }),
                    _c(
                      "div",
                      { staticClass: "h5 mb-0 mt-2" },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "text-nowrap",
                                attrs: { md: "auto" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.project.name) +
                                    "\n                "
                                ),
                                _vm.project.version
                                  ? _c(
                                      "ol",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          margin: "0",
                                          "list-style-type": "none",
                                          "padding-inline-start": "0",
                                        },
                                      },
                                      [
                                        _c("li", { staticClass: "dropdown" }, [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "#",
                                                "data-toggle": "dropdown",
                                                role: "button",
                                                "aria-haspopup": "true",
                                                "aria-expanded": "false",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-caret-down",
                                                staticStyle: {
                                                  "padding-left": "10px",
                                                  "padding-right": "10px",
                                                  "padding-top": "3px",
                                                  "padding-bottom": "3px",
                                                },
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "ul",
                                            { staticClass: "dropdown-menu" },
                                            [
                                              _vm._l(
                                                _vm.activeProjectVersions,
                                                function (projectVersion) {
                                                  return _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "b-dropdown-item",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name: "Project",
                                                              params: {
                                                                uuid: projectVersion.uuid,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                projectVersion.version
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _vm.inactiveProjectVersions
                                                .length > 0
                                                ? _c(
                                                    "b-dropdown-group",
                                                    {
                                                      attrs: {
                                                        header: _vm.$t(
                                                          "message.inactive_versions"
                                                        ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.inactiveProjectVersions,
                                                      function (
                                                        projectVersion
                                                      ) {
                                                        return _c(
                                                          "span",
                                                          [
                                                            _c(
                                                              "b-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  to: {
                                                                    name: "Project",
                                                                    params: {
                                                                      uuid: projectVersion.uuid,
                                                                    },
                                                                  },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      projectVersion.version
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.project.version) +
                                    "\n                "
                                ),
                                _vm.isCollectionProject
                                  ? _c("i", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            title: _vm.getCollectionLogicText(
                                              _vm.project
                                            ),
                                          },
                                          expression:
                                            "{\n                    title: getCollectionLogicText(project),\n                  }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass:
                                        "fa fa-calculator fa-fw collectionlogic-icon",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            !this.project.active
                              ? _c(
                                  "b-badge",
                                  { attrs: { variant: "tab-warn" } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm
                                            .$t("message.inactive")
                                            .toUpperCase()
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            this.project.isLatest
                              ? _c(
                                  "b-badge",
                                  { attrs: { variant: "tab-info" } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm
                                            .$t("message.latest_version")
                                            .toUpperCase()
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c("b-col", { staticClass: "d-none d-md-flex" }, [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: { title: _vm.project.description },
                                      expression:
                                        "{ title: project.description }",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass:
                                    "text-muted font-xs font-italic align-text-top text-truncate",
                                  staticStyle: { "max-width": "100ch" },
                                },
                                [_vm._v(_vm._s(_vm.project.description))]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "text-muted font-xs" }, [
                      _c(
                        "span",
                        { staticClass: "text-lowercase font-weight-bold" },
                        _vm._l(_vm.project.tags, function (tag) {
                          return _c(
                            "span",
                            [
                              _c(
                                "b-badge",
                                {
                                  attrs: {
                                    to: {
                                      name: "Projects",
                                      query: { tag: tag.name },
                                    },
                                    variant: "tag",
                                  },
                                },
                                [_vm._v(_vm._s(tag.name))]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                  _c(
                    "b-col",
                    { attrs: { md: "auto" } },
                    [
                      _c(
                        "b-row",
                        { staticClass: "d-none d-md-flex float-right" },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityCritical,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("vulnerability.critical"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentCritical))]
                          ),
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityHigh,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("vulnerability.high"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentHigh))]
                          ),
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityMedium,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("vulnerability.medium"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentMedium))]
                          ),
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityLow,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("vulnerability.low"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentLow))]
                          ),
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityUnassigned,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("vulnerability.unassigned"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentUnassigned))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              attrs: { slot: "footer", id: "project-info-footer" },
              slot: "footer",
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-link",
                        {
                          staticClass:
                            "font-weight-bold font-xs btn-block text-muted",
                          on: { click: _vm.initializeProjectDetailsModal },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("message.view_details")) +
                              "\n            "
                          ),
                          _c("i", { staticClass: "fa fa-angle-right font-lg" }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.project.externalReferences
                    ? _c(
                        "b-col",
                        { attrs: { md: "auto" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "d-none d-md-flex float-right" },
                            [
                              _c("ExternalReferencesDropdown", {
                                attrs: {
                                  externalReferences:
                                    _vm.project.externalReferences,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: {
            "border-left": "0",
            "border-right": "0",
            "border-top": "0",
          },
        },
        [
          _c(
            "b-tab",
            {
              ref: "overview",
              staticClass: "body-bg-color overview-chart",
              staticStyle: {
                "border-left": "0",
                "border-right": "0",
                "border-top": "0",
              },
              attrs: { active: "" },
              on: {
                click: function ($event) {
                  return _vm.routeTo()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-line-chart" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.overview"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("project-dashboard", {
                key: this.uuid,
                staticStyle: {
                  "border-left": "0",
                  "border-right": "0",
                  "border-top": "0",
                },
                attrs: { uuid: this.uuid, project: this.project },
              }),
            ],
            1
          ),
          _vm.isShowComponents
            ? _c(
                "b-tab",
                {
                  ref: "components",
                  on: {
                    click: function ($event) {
                      return _vm.routeTo("components")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "fa fa-cubes" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.components")) +
                                "\n        "
                            ),
                            _c("b-badge", { attrs: { variant: "tab-total" } }, [
                              _vm._v(_vm._s(_vm.totalComponents)),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3910654322
                  ),
                },
                [
                  _c("project-components", {
                    key: this.uuid,
                    attrs: { uuid: this.uuid, project: this.project },
                    on: {
                      total: function ($event) {
                        _vm.totalComponents = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowCollectionProjects
            ? _c(
                "b-tab",
                {
                  ref: "collectionprojects",
                  attrs: { lazy: "" },
                  on: {
                    click: function ($event) {
                      return _vm.routeTo("collectionprojects")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "fa fa-sitemap" }),
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("message.collection_projects"))
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2797961238
                  ),
                },
                [
                  _c("project-collection-projects", {
                    key: this.uuid,
                    attrs: { uuid: this.uuid, project: this.project },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowServices
            ? _c(
                "b-tab",
                {
                  ref: "services",
                  on: {
                    click: function ($event) {
                      return _vm.routeTo("services")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "fa fa-exchange" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.services")) +
                                "\n        "
                            ),
                            _c("b-badge", { attrs: { variant: "tab-total" } }, [
                              _vm._v(_vm._s(_vm.totalServices)),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4288693035
                  ),
                },
                [
                  _c("project-services", {
                    key: this.uuid,
                    attrs: { uuid: this.uuid },
                    on: {
                      total: function ($event) {
                        _vm.totalServices = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowDependencyGraph
            ? _c(
                "b-tab",
                {
                  ref: "dependencygraph",
                  on: {
                    click: function ($event) {
                      return _vm.routeTo("dependencyGraph")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "fa fa-sitemap" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.dependency_graph")) +
                                "\n        "
                            ),
                            _c("b-badge", { attrs: { variant: "tab-total" } }, [
                              _vm._v(_vm._s(_vm.totalDependencyGraphs)),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2640515563
                  ),
                },
                [
                  _c("project-dependency-graph", {
                    key: this.uuid,
                    attrs: { uuid: this.uuid, project: this.project },
                    on: {
                      total: function ($event) {
                        _vm.totalDependencyGraphs = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowFindings
            ? _c(
                "b-tab",
                {
                  ref: "findings",
                  on: {
                    click: function ($event) {
                      return _vm.routeTo("findings")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "fa fa-tasks" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("message.audit_vulnerabilities")
                                ) +
                                "\n        "
                            ),
                            _c(
                              "b-badge",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "tab-total",
                                  title: _vm.$t(
                                    "message.total_findings_excluding_aliases"
                                  ),
                                },
                              },
                              [_vm._v(_vm._s(_vm.totalFindings))]
                            ),
                            _c(
                              "b-badge",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "tab-info",
                                  title: _vm.$t(
                                    "message.total_findings_including_aliases"
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.totalFindingsIncludingAliases)
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2420490324
                  ),
                },
                [
                  _c("project-findings", {
                    key: this.uuid,
                    attrs: { uuid: this.uuid },
                    on: {
                      total: function ($event) {
                        _vm.totalFindingsIncludingAliases = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowFindings
            ? _c(
                "b-tab",
                {
                  ref: "epss",
                  on: {
                    click: function ($event) {
                      return _vm.routeTo("epss")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "fa fa-tasks" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.exploit_predictions")) +
                                "\n        "
                            ),
                            _c("b-badge", { attrs: { variant: "tab-total" } }, [
                              _vm._v(_vm._s(_vm.totalEpss)),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    427665009
                  ),
                },
                [
                  _c("project-epss", {
                    key: this.uuid,
                    attrs: { uuid: this.uuid },
                    on: {
                      total: function ($event) {
                        _vm.totalEpss = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowPolicyViolations
            ? _c(
                "b-tab",
                {
                  ref: "policyviolations",
                  on: {
                    click: function ($event) {
                      return _vm.routeTo("policyViolations")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "fa fa-fire" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.policy_violations")) +
                                "\n        "
                            ),
                            _c(
                              "b-badge",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "tab-total",
                                  title: _vm.$t("policy_violation.total"),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.policyViolationsTotal
                                    /*showSuppressedViolations
              ? policyViolationsTotal
              : policyViolationsUnaudited*/
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "b-badge",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "tab-info",
                                  title: _vm.$t("policy_violation.infos"),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.policyViolationsInfoTotal
                                    /*showSuppressedViolations
              ? policyViolationsInfoTotal
              : policyViolationsInfoUnaudited*/
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "b-badge",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "tab-warn",
                                  title: _vm.$t("policy_violation.warns"),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.policyViolationsWarnTotal
                                    /*showSuppressedViolations
              ? policyViolationsWarnTotal
              : policyViolationsWarnUnaudited*/
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "b-badge",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "tab-fail",
                                  title: _vm.$t("policy_violation.fails"),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.policyViolationsFailTotal
                                    /*showSuppressedViolations
              ? policyViolationsFailTotal
              : policyViolationsFailUnaudited*/
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2583339461
                  ),
                },
                [
                  _c("project-policy-violations", {
                    key: this.uuid,
                    attrs: { uuid: this.uuid },
                    on: {
                      showSuppressedViolations: function ($event) {
                        _vm.showSuppressedViolations = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("project-details-modal", {
        attrs: { project: _vm.cloneDeep(_vm.project), uuid: this.uuid },
        on: { projectUpdated: _vm.syncProjectFields },
      }),
      _c("project-properties-modal", { attrs: { uuid: this.uuid } }),
      _c("project-create-property-modal", { attrs: { uuid: this.uuid } }),
      _c("project-add-version-modal", { attrs: { uuid: this.uuid } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }